import MOModalWrapper from "../../../../components/commons/MOModalWrapper";

const UserProfileModal = ({ modalOpen, setModalOpen, userImageLink }) => {
  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={`User Profile Picture`}
      className={"country-city-modal header-modal-section"}
    >
      <div
        className="flex"
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <img
          style={{
            width: "330px",
            height: "350px",
            display: "block",
            borderRadius: "8px",
            // objectFit: "cover",
          }}
          src={userImageLink || "https://avatar.iran.liara.run/public/29"}
          alt="Onboarding user profile picture"
        />
      </div>
    </MOModalWrapper>
  );
};

export default UserProfileModal;
